<template>
</template>

<script>
export default {
    data: function () {
        return {
            disableOnSubmit: false,
            loginForm: {
                password: false,
                save_card: 0,
            },
            register: {
                new_user_key: this.newUserKey,
                password: '',
                password_confirmation: '',
            },
            showContent: false,
            loginFailure: false,
        }
    },
    props: [
        'modalType',
        'newUserKey',
        'user',
        'saveCardOption',
        'paymentDetails',
        'createPasswordUrl',
        'loginUrl',
    ],
    mounted() {
        $('#login-or-create-password-modal').modal({backdrop: 'static', keyboard: false});

        setTimeout(function () {
            this.showContent = true;
        }.bind(this), 200);

        // this.user = {email: 'test@test.com', first_name: 'Alex Test'};
        // this.paymentStatus = 'success-new';
    },
    watch: {
    },

    methods: {
        login() {
            let postData = {
                email: this.user.email,
                password: this.loginForm.password,
                save_card: this.loginForm.save_card,
                card_hashid: this.paymentDetails.card
            }

            this.$validator.validateAll('loginForm').then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    this.attemptLogin(postData);
                }
            });
        },
        attemptLogin(postData) {
            axios
                .post(this.loginUrl, postData)
                .then(response => {
                    // On success, redirect to the provided URL
                    window.location = response.data.redirectUrl;
                })
                .catch(error => {

                    let response = error.response.data;

                    if (_.has(response, 'errors.email')) {
                        this.loginFailure = response.errors.email[0];
                    };
                });
        },


        createPasswordAndLogin() {
            this.$validator.validateAll('register').then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    this.createPassword();
                }
            });

        },
        createPassword() {
            axios
                .post(this.createPasswordUrl, this.register)
                .then(response => {
                    // On success, redirect to the provided URL
                    window.location = response.data.redirectUrl;
                })
                .catch(error => {
                    let errorData = error.response.data;

                    if (_.has(errorData, 'errors.password')) {
                        alert('Your password is not strong enough. Please use at least 8 characters.');
                    } else if (_.has(errorData, 'errors.new_user_key')) {
                        alert('There has been an unexpected error. Please contact MotorCheck support.');
                    }
                });
        },

        validationClass(hasErrors) {
            return this.$parent.validationClass(hasErrors);
        },
    },
    components: {
    }
}
</script>